<template>
  <section class="top-section">
    <div class="left">
      <template>
        <div class="image-gallery" v-if="images && images.length > 0">
          <div class="thumb-wrapper">
            <div
              v-if="images && images.length > 4"
              class="arrow-for-more up-arrow"
              @click="goToPrev()"
            >
              <Icon height="35" icon="mdi:chevron-down-circle-outline" />
            </div>
            <div class="thumbnails">
              <no-ssr>
                <vue-tiny-slider
                  ref="tinySlider1"
                  v-bind="tinysettingsthumbs"
                  id="thumbnails"
                >
                  <div
                    v-for="(item, index) in images"
                    :key="index + 'thmb'"
                    class="thumbnail"
                    aria-controls="customize"
                    @click="goToIndexThumbs(index)"
                  >
                    <nuxt-img
                      quality="90"
                      format="webp"
                      placeholder
                      :src="item.desktop.url"
                      draggable="false"
                      :alt="item.alt"
                    />
                  </div>
                </vue-tiny-slider>
              </no-ssr>
            </div>
            <div
              v-if="images && images.length > 4"
              class="arrow-for-more"
              @click="goToNext()"
            >
              <Icon height="35" icon="mdi:chevron-down-circle-outline" />
            </div>
          </div>
          <div class="main-view">
            <no-ssr>
              <vue-tiny-slider ref="tinySlider" v-bind="tinysettings" id="customize">
                <div
                  v-for="(item, index) in images"
                  :key="index + 'img'"
                  class="image"
                  aria-controls="thumbnails"
                  @click="goToIndex()"
                >
                  <div class="image-wrapper">
                    <nuxt-img
                      quality="90"
                      format="webp"
                      placeholder
                      :src="item.desktop.url"
                      draggable="false"
                      :alt="item.alt"
                    />
                  </div>
                </div>
              </vue-tiny-slider>
            </no-ssr>
          </div>
        </div>
      </template>
    </div>
    <div class="right">
      <div class="buy">
        <div v-if="isAuthenticated" class="loggedin">
          <h1 class="mont title">{{ product.name }}</h1>
          <div class="product-info">
            <p>
              {{ $t("Article number") }}:
              <span>{{ product.sku }}</span>
            </p>
            <p>
              {{ $t("Barcode") }}:
              <span>{{ product.barcode }}</span>
            </p>
            <p v-if="brandData">
              {{ $t("Brand") }}:
              <span>{{ brandData.label }}</span>
            </p>
          </div>
          <div class="stock">
            <span
              v-if="parseInt(product.shots_stock) > 0"
              class="in-stock traffic-green font-fgb"
              >{{ product.shots_stock }} {{ $t("in stock") }}</span
            >
            <span v-else class="in-stock traffic-red font-fgb">{{
              $t("Out of stock")
            }}</span>
            <div
              class="in-production"
              v-show="product.expected_stock && product.expected_stock > 0"
            >
              <span class="traffic-yellow font-fgb"
                >{{ product.expected_stock }} {{ $t("in production") }}</span
              >
              <span v-if="product.expected_stock_date"
                >{{ $t("Est. arrival") }}
                {{ new Date(product.expected_stock_date).toLocaleDateString() }}</span
              >
            </div>
          </div>
          <div class="price">
            <div class="retail">
              <p class="font-fgb">
                {{ $t("Retail price") }}
                <span class="vat-notice font-fgb"
                  >(incl. {{ vatText }} {{ $t("VAT") }})</span
                >
              </p>
              <p>{{ $fc(productGetters.getPrice(product).regular) }}</p>
            </div>
            <div class="wholesale">
              <p class="font-fgb">
                {{ $t("Wholesale price") }}
                <span class="vat-notice font-fgb"
                  >(excl. {{ vatText }} {{ $t("VAT") }})</span
                >
              </p>
              <p class="font-fgb" v-if="yourPrice > 0">
                {{ $fc(wholesalePrice) }}
              </p>
              <div v-else>
                <div class="lds-spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="specific-customer">
            <div class="margin">
              <p class="font-fgb">{{ $t("Your discount") }}</p>
              <p class="font-fgb">{{ yourDiscount }}%</p>
            </div>
            <div class="margin">
              <p class="font-fgb">{{ $t("Your margin") }}</p>
              <p v-if="productGetters.getPrice(product).regular === 0">-</p>
              <p v-else-if="yourPrice > 0" class="font-fgb">{{ priceMargin }}%</p>
              <div v-else>
                <div class="lds-spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
            <div class="customer-price">
              <p class="font-fgb">
                {{ $t("Your price") }}
                <span class="vat-notice font-fgb"
                  >(excl. {{ vatText }} {{ $t("VAT") }})</span
                >
              </p>
              <p class="font-fgb" v-if="yourPrice > 0">{{ $fc(yourPrice) }}</p>
              <div v-else>
                <div class="lds-spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="add-to-cart"
            v-show="
              isAuthenticated && !(product.exclude_for && isDropshipper) && !loveSenseRule
            "
          >
            <div class="quantity">
              <input type="number" v-model="qty" @change="updatePrice()" />
            </div>
            <button class="btn" @click="addProductToCart(product, qty)">
              {{ $t("Add to cart") }}
            </button>
          </div>
          <div class="case-count" v-if="product.master_case_qty">
            {{ $t("Case count:") }} {{ product.master_case_qty }}
          </div>
          <p class="wishlist font-fgb" @click="addItemToWishlist({ product })">
            <Icon
              height="25"
              :icon="isInWishlist ? 'mdi:cards-heart' : 'mdi:cards-heart-outline'"
            />{{
              isInWishlist
                ? $t("Remove this product from wishlist")
                : $t("Add this product to wishlist")
            }}
          </p>
          <div
            class="product-overlay"
            v-show="
              (isAuthenticated && product.exclude_for && isDropshipper) || loveSenseRule
            "
          >
            <div class="overlay-message">
              {{ $t("Product not available") }}
            </div>
          </div>
        </div>
        <div v-else class="loggedout">
          <h1 class="mont title">{{ product.name }}</h1>
          <div class="rec-price-wrapper">
            <p class="recommended-price">
              {{ $t("Recommended Retail Price:") }}
            </p>
            <p class="regular">{{ $fc(productPrice) }}</p>
          </div>
          <div class="promo">
            <p>
              <img
                src="~/assets/icons/icons/USP_Icons-Extensive-Inventory.png"
                alt="box icon"
                class="w-8 h-auto mr-2"
              />
              <span class="font-fgb">
                {{ $t("Extensive Inventory") }}
              </span>
            </p>
            <p>
              <img
                src="~/assets/icons/icons/USP_Icons-Swift-Global-Delivery.png"
                alt="box icon"
                class="w-8 h-auto mr-2"
              />
              <span class="font-fgb">
                {{ $t("Swift Global Delivery") }}
              </span>
            </p>
            <p>
              <img
                src="~/assets/icons/icons/USP_Icons-European-excellence.png"
                alt="box icon"
                class="w-8 h-auto mr-2"
              />
              <span class="font-fgb">
                {{ $t("European excellence in products and development") }}
              </span>
            </p>
          </div>
          <button class="btn" @click="$router.push(localePath('/register'))">
            {{ $t("Become a Shots B2B partner") }}
          </button>
        </div>
      </div>
      <div class="desc" v-if="product.description">
        <p class="desc-text font-fgb">
          {{ extractContent(product.description.html) }}
        </p>
        <p class="read-more font-fgb" @click="scrollToTab(1)">
          {{ $t("Read more") }}
        </p>
      </div>
      <div class="brand" v-if="brandData">
        <nuxt-link
          :to="localePath(`/brand/${brandData.url}`)"
          v-if="brandData.img && brandData.img.length > 0"
        >
          <nuxt-img
            quality="90"
            format="webp"
            placeholder
            v-if="brandData.img && brandData.img.length > 0"
            :src="brandData.img"
            alt="brand image"
            class="brand-image"
          />
        </nuxt-link>
        <h3 v-else>{{ brandData.label }}</h3>
        <p class="brand-text">
          {{ brandData.short_description }}
        </p>
        <p
          class="all-prod font-fgb"
          @click="
            $router.push(
              localePath(`/${brandDefaultUrl}.html?brand=` + brandData.brandId)
            )
          "
        >
          {{ $t("All products") }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import {
  defineComponent,
  computed,
  ref,
  useContext,
  onMounted,
} from "@nuxtjs/composition-api";
import { SfGallery } from "@storefront-ui/vue";
import { getPrice as getProductPrice } from "~/modules/catalog/product/getters/productGetters";
import { Icon } from "@iconify/vue2";
import { useAddToCart } from "~/helpers/cart/addToCart";
import useWishlist from "~/modules/wishlist/composables/useWishlist";
import { useUser } from "~/modules/customer/composables/useUser";
import productGetters from "~/modules/catalog/product/getters/productGetters";
import HTMLContent from "~/components/HTMLContent.vue";
import { useBrandsStore } from "~/stores/brands";
// import useStock from "~/composables/useStock";
import useSalePrice from "~/composables/useSalePrice";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";

export default defineComponent({
  name: "ProductTopSection",
  components: {
    SfGallery,
    Icon,
    HTMLContent,
    HTMLContent,
  },
  props: {
    product: {
      default: null,
    },
  },
  setup(props, { emit }) {
    const {
      app: { i18n, $cookies },
    } = useContext();
    const { isAuthenticated, userAdv } = useUser();
    const qty = ref(1);
    const { addItemToCart } = useAddToCart();
    const { addOrRemoveItem, isInWishlist } = useWishlist();
    const brandsStore = useBrandsStore();
    const brandData = computed(() => brandsStore.getBrandById(props.product.brand));
    const categories = useCategoryStore();

    // const { getSingleProductStock } = useStock();
    const { getSalePrices } = useSalePrice();

    const isDropshipper = computed(() => userAdv?.value?.is_dropshipper);
    const customerGroupId = computed(() => userAdv?.value?.custom_group_id);

    const isForbiddenCountry = computed(() => {
      const forbiddenCountries = ["RU", "GB", "UA", "TR"];
      const userCountry = $cookies.get("ip-country")?.split(".")[0];
      if (userCountry) {
        return forbiddenCountries.includes(userCountry);
      } else {
        return false;
      }
    });

    const loveSenseRule = computed(() => {
      return (
        (customerGroupId.value === 5 &&
          brandsStore.getBrandById(props.product.brand) &&
          brandsStore.getBrandById(props.product.brand).label === "Lovense") ||
        (isForbiddenCountry.value &&
          brandsStore.getBrandById(props.product.brand) &&
          brandsStore.getBrandById(props.product.brand).label === "Lovense")
      );
    });

    const stockData = ref(false);
    const priceData = ref(null);

    const amountInStock = computed(() => stockData.value?.availableInventory);
    const amountInProduction = computed(() => {
      if (stockData.value && stockData.value.nextExpectedReceiptAvailable) {
        return stockData.value.nextExpectedReceipts[0];
      } else {
        return false;
      }
    });
    const showAmountInProd = computed(() => {
      if (stockData.value && stockData.value.nextExpectedReceiptAvailable) {
        return true;
      } else {
        return false;
      }
    });

    const wholesalePrice = computed(() => {
      if (priceData.value) {
        return priceData.value.salesPriceLines[0].wholesalePrice;
      } else {
        return 0;
      }
    });

    const yourPrice = computed(() => {
      if (priceData.value) {
        return priceData.value.salesPriceLines[0].unitPrice;
      } else {
        return 0;
      }
    });

    const vatText = computed(() => {
      if (props.product.fe_tax === "High") {
        return "21%";
      } else if (props.product.fe_tax === "Low") {
        return "9%";
      } else {
        return "0%";
      }
    });

    const productTaxMargin = computed(() => {
      if (props.product.fe_tax === "High") {
        return 1.21;
      } else if (props.product.fe_tax === "Low") {
        return 1.09;
      } else {
        return 1;
      }
    });

    const priceMargin = computed(() => {
      if (priceData.value && productTaxMargin.value) {
        return (
          ((productPrice.value / productTaxMargin.value -
            priceData.value.salesPriceLines[0].unitPrice) /
            (productPrice.value / productTaxMargin.value)) *
          100
        ).toFixed();
      } else {
        return 0;
      }
    });

    const yourDiscount = computed(() => {
      if (priceData.value) {
        return (
          ((wholesalePrice.value - yourPrice.value) / wholesalePrice.value) *
          100
        ).toFixed();
      } else {
        return 0;
      }
    });

    const images = computed(() => {
      // First, create the array of images
      let imageArray = props.product?.media_gallery
        ?.map((i) => {
          if (!i.disabled) {
            return {
              desktop: { url: i.url },
              mobile: { url: i.url },
              zoom: { url: i.url },
              alt: props.product.name,
              placeholder: "https://via.placeholder.com/600x800",
            };
          }
        })
        .filter((f) => f); // Filter out any undefined values

      // Define the condition for the match (e.g., matching a specific URL)
      const targetUrl = props.product.image.url;

      // Find the index of the matching item
      const matchIndex = imageArray.findIndex((image) => image.desktop.url === targetUrl);

      // If a match is found, move it to the first position
      if (matchIndex > -1) {
        const [matchedImage] = imageArray.splice(matchIndex, 1); // Remove the matched item
        imageArray.unshift(matchedImage); // Add the matched item to the start of the array
      }

      return imageArray;
    });

    const tinysettings = {
      container: "#customize",
      mouseDrag: true,
      loop: false,
      controls: false,
      nav: true,
      "nav-container": false,
      items: 1,
      swipeAngle: false,
      speed: 200,
      edgePadding: 0,
      gutter: 0,
      startIndex: 0,
      autoHeight: true,
    };

    const tinysettingsthumbs = {
      container: "#thumbnails",
      nav: true,
      mouseDrag: true,
      loop: false,
      controls: false,
      "nav-container": false,
      items: 3,
      swipeAngle: false,
      speed: 200,
      edgePadding: 0,
      gutter: 0,
      axis: process.client
        ? window.innerWidth <= "768"
          ? "horizontal"
          : "vertical"
        : "vertical",
      startIndex: 0,
      arrowKeys: false,
      gutter: 10,
      responsive: {
        480: {
          items: 4,
        },
      },
    };

    const productPrice = computed(() => getProductPrice(props.product).regular);

    const scrollToTab = (tab) => {
      const tabs = document.querySelector("#tabs");

      if (!tabs) return props.openTab;
      tabs.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
      emit("changeTab", tab);
    };

    const addProductToCart = (product, qty) => {
      if (product.exclude_for && isDropshipper.value) return;
      addItemToCart({ product, quantity: qty });
    };

    const querySalePrices = async () => {
      const skus = [
        {
          itemNo: props.product.sku,
          quantity: parseInt(qty.value),
        },
      ];
      priceData.value = await getSalePrices(skus);
    };

    const updatePrice = () => {
      querySalePrices();
    };

    onMounted(async () => {
      // stockData.value = await getSingleProductStock(props.product.sku);

      querySalePrices();
    });

    return {
      isAuthenticated,
      images,
      productPrice,
      qty,
      addItemToWishlist: addOrRemoveItem,
      isInWishlist: computed(() => isInWishlist({ product: props.product })),
      scrollToTab,
      tinysettings,
      tinysettingsthumbs,
      productGetters,
      brandData,
      stockData,
      amountInStock,
      amountInProduction,
      showAmountInProd,
      addProductToCart,
      priceData,
      wholesalePrice,
      priceMargin,
      updatePrice,
      vatText,
      yourPrice,
      brandDefaultUrl: computed(() => categories.brandDefaultUrl),
      isDropshipper,
      yourDiscount,
      isForbiddenCountry,
      brandsStore,
      loveSenseRule,
    };
  },
  methods: {
    goToIndex() {
      setTimeout(() => {
        this.$refs.tinySlider1.slider.goTo(this.$refs.tinySlider.slider.getInfo().index);
      }, 250);
    },
    goToIndexThumbs(index) {
      setTimeout(() => {
        this.$refs.tinySlider.slider.goTo(index);
      }, 250);
    },
    goToNext() {
      this.$refs.tinySlider.slider.goTo("next");
      this.$refs.tinySlider1.slider.goTo("next");
    },
    goToPrev() {
      this.$refs.tinySlider.slider.goTo("prev");
      this.$refs.tinySlider1.slider.goTo("prev");
    },
    extractContent(htmlString) {
      if (process.client) {
        // Remove CSS by replacing style tags and everything inside them with an empty string
        var withoutCSS = htmlString.replace(/<style([\s\S]*?)<\/style>/gi, "");

        // Remove HTML tags by replacing them with an empty string
        var withoutTags = withoutCSS.replace(/<\/?[a-z][^>]*>/gi, "");

        // Remove &nbsp; by replacing it with an empty string
        var withoutNbsp = withoutTags.replace(/&nbsp;/gi, "");

        // Remove extra whitespace and line breaks
        var cleanedText = withoutNbsp.replace(/\s{2,}/g, " ").trim();

        // Cut the string after 200 characters and add three dots
        if (cleanedText.length > 200) {
          cleanedText = cleanedText.substring(0, 200) + "...";
        }

        return cleanedText;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.top-section {
  @apply flex justify-between;
  @media screen and (max-width: 768px) {
    gap: 20px;
  }
  .left {
    max-width: 1100px;
    max-height: 800px;
    @media screen and (max-width: 768px) {
      max-height: none;
    }
    .image-gallery {
      @apply flex gap-4;
      .thumb-wrapper {
        @apply relative;
        .thumbnails {
          .thumbnail {
            @apply border-solid border border-grey p-1 rounded-sm cursor-pointer;
            width: 150px;
            height: 150px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        .arrow-for-more {
          position: absolute;
          bottom: -10px;
          left: -25%;
          display: flex;
          justify-content: center;
          width: 150%;
          background: rgba(255, 255, 255, 0.801);
          height: 70px;
          border-top: 2px solid #e8e8e8;
          cursor: pointer;
          z-index: 2;
          &.up-arrow {
            transform: rotate(180deg);
            bottom: auto;
            top: -10px;
          }
        }
      }

      .main-view {
        @apply pr-8;
        .image {
          .image-wrapper {
            height: 600px;
            @media screen and (max-width: 768px) {
              height: auto;
            }
            img {
              object-fit: contain;
            }
          }
        }
      }
      @media screen and (max-width: 768px) {
        @apply flex-col;
        .thumb-wrapper {
          order: 2;
          .tns-ovh {
            height: auto !important;
          }
          #thumbnails {
            @apply flex;
            gap: 10px;
          }
          .arrow-for-more {
            width: 35px;
            right: 0;
            left: auto;
            bottom: 0;
            height: 150px;
            align-items: center;
            border: 0 none;
            svg {
              transform: rotate(-90deg);
            }
            &.up-arrow {
              transform: rotate(180deg);
              right: auto;
              left: 0;
              bottom: 0;
              top: auto;
            }
          }
        }

        .main-wrapper {
          order: 1;
        }
        .main-view {
          padding-right: 0;
        }
      }
    }
  }
  .right {
    @apply bg-light-grey rounded-xl py-4 px-4;
    margin-top: -3.5rem;
    width: 450px;
    .buy {
      @apply mb-4 px-4 relative;
      .loggedin {
        .title {
          @apply text-3xl font-mont font-bold text-black mb-4;
        }
        .product-info {
          @apply flex flex-wrap flex-col font-fgb justify-start gap-2 mb-4;
          p {
            @apply text-sm py-0 mt-0;
            span {
              @apply font-bold;
            }
          }
        }
        .stock {
          @apply flex justify-between text-xs mb-2;
          .in-production {
            @apply flex flex-col;
            span {
              @apply mb-1;
            }
          }
        }

        .traffic-green {
          @apply text-green relative pl-4;
          &::before {
            @apply bg-green absolute;
            left: 0;
            top: 2px;
            content: "";
            display: inline-block;
            width: 12px;
            height: 12px;
            -moz-border-radius: 8.5px;
            -webkit-border-radius: 8.5px;
            border-radius: 8.5px;
          }
        }
        .traffic-yellow {
          @apply text-orange relative pl-4;
          &::before {
            @apply bg-orange absolute;
            left: 0;
            top: 2px;
            content: "";
            display: inline-block;
            width: 12px;
            height: 12px;
            -moz-border-radius: 8.5px;
            -webkit-border-radius: 8.5px;
            border-radius: 8.5px;
          }
        }
        .traffic-red {
          @apply text-warm-red relative pl-4;
          &::before {
            @apply bg-warm-red absolute;
            left: 0;
            top: 2px;
            content: "";
            display: inline-block;
            width: 12px;
            height: 12px;
            -moz-border-radius: 8.5px;
            -webkit-border-radius: 8.5px;
            border-radius: 8.5px;
          }
        }

        .price {
          @apply text-xs;
          .retail {
            p {
              @apply font-fgb;
            }
          }
          .retail,
          .wholesale {
            @apply flex justify-between mb-1;
          }
        }

        .vat-notice {
          color: #707070;
        }

        .specific-customer {
          @apply text-xs my-2 pt-2;
          border-top: 2px solid #eeeeee;
          .margin,
          .customer-price {
            @apply flex justify-between mb-1;
          }
          .customer-price {
            @apply font-bold text-base;
          }
        }
        .quantity {
          @apply flex justify-start gap-2 items-center;
          p {
            @apply text-base text-brownish-grey;
          }
          input {
            @apply font-bold text-base font-suwa;
            border: 1px solid #e8e8e8;
            width: 50px;
            border-radius: 20px;
            padding: 5px;
            text-align: center;
          }

          /* Chrome, Safari, Edge, Opera */
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          /* Firefox */
          input[type="number"] {
            -moz-appearance: textfield;
          }
        }
        .add-to-cart {
          @apply flex items-center gap-4 mt-4;
          .qty {
            @apply border-2 border-solid border-grey rounded-full pl-5 pr-2 text-xl flex items-center gap-1;
          }
          .btn {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
          }
        }
        .case-count {
          @apply text-xs mt-2 font-fgb;
        }
        .wishlist {
          @apply flex items-center gap-2 cursor-pointer mt-4;
        }

        .product-overlay {
          @apply absolute rounded-3xl flex justify-center;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: rgba(255, 255, 255, 0.8);
          .overlay-message {
            @apply px-4 py-3 text-xl text-center max-w-[80%] mx-auto text-white rounded-2xl uppercase font-mont font-bold;
            background: rgb(227, 6, 19);
            background: linear-gradient(
              90deg,
              rgba(227, 6, 19, 1) 0%,
              rgba(167, 3, 3, 1) 68%
            );
            margin: 0;
            position: absolute;
            top: 50%;
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
          }
        }
      }
      .loggedout {
        .title {
          @apply text-3xl font-mont font-bold text-black mb-4;
        }
        .order {
          @apply text-xl my-0;
        }
        .rec-price-wrapper {
          @apply flex items-center gap-2 mt-2;
          .recommended-price {
            @apply text-xs my-0 text-black;
          }
          .regular {
            @apply text-fire-red text-2xl font-bold my-0;
          }
        }
        .promo {
          @apply flex flex-col text-brownish-grey mt-2;
          p {
            @apply my-1 flex items-center justify-start;
            .iconify {
              @apply mr-2;
            }
          }
        }
        .btn {
          @apply mt-4;
        }
      }
    }
    .desc {
      @apply py-8 border-0 border-t border-grey border-solid px-4;
      .desc-text {
        @apply mt-0 mb-2;
      }
      .read-more {
        @apply text-fire-red cursor-pointer my-0;
      }
    }
    .brand {
      @apply py-8 border-0 border-t border-grey border-solid px-4;
      .brand-text {
        @apply mt-0 mb-2 font-fgb text-base;
      }
      .brand-image {
        @apply mb-4;
        max-width: 100%;
        max-height: 90px;
        height: auto;
        width: auto;
      }
      h3 {
        @apply font-mont text-5xl mb-2;
      }
      .all-prod {
        @apply text-fire-red cursor-pointer my-0;
      }
    }
  }
  @media screen and (max-width: 1536px) {
    .left {
      max-width: 800px;
    }
    .right {
      @apply w-full mt-0;
    }
  }
  @media screen and (max-width: 1200px) {
    @apply flex-col;
    .right {
      @apply w-full mt-0;
    }
  }
}
</style>
